<template>
  <div class="ms" style="width:1280px;margin:0 auto">
    <div class="head-nav">
      <div style="
         height: 31px;
         display:flx;
         font-size: 24px;
         font-family: Microsoft YaHei;
         font-weight: bold;
         line-height: 26px;
         color: #F43626;
         opacity: 1;"><img style="margin-right:10px" src="../../../static/img/yszs.png">高考咨询</div>
      <div :class="navIndex==index?'activite':''" @click="checkIndex(index)" style="font-size:20px;color:#F43626;width:80px;padding:0px;margin-right:30px" v-for="(item,index) in navList" :key='index'>{{item}}
      </div>
    </div>
    <!-- <div class="card-carousel-wrapper">
      <div class="card-carousel--nav__left" @click="moveCarousel(-1)" :disabled="atHeadOfList"></div>
      <div class="card-carousel">
        <div class="card-carousel--overflow-container">
          <div class="card-carousel-cards" :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}">
            <div class="itemtt" v-for="(item,index) in list" :key="index">
              <div class="img">
                <div class="star"><img :src="item.star" alt=""></div>
                <img class="texttt" :src="item.image" alt="">
                <div class="no">排名：{{item.no}}</div>
              </div>
              <div class="name">{{item.text}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-carousel--nav__right" @click="moveCarousel(1)" :disabled="atEndOfList"></div>
    </div> -->
    <div class="box">
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <div class="dahezi">
            <div class="stars"><img class="imgass" :src="item.star" alt=""></div>
            <div class="qinhua"><img :src="item.image" alt="" class="imgss"></div>
            <div class="no">排名：{{item.no}}</div>
            <div class="name">{{item.text}}</div>
          </div>

          <div class="dahezi">
            <div class="stars"><img class="imgass" :src="item.star" alt=""></div>
            <div class="qinhua"><img :src="item.image" alt="" class="imgss"></div>
            <div class="no">排名：{{item.no}}</div>
            <div class="name">{{item.text}}</div>
          </div>

        </li>
      </ul>
    </div>
    <div class="button" @click="tiaozhuan">查看更多</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navIndex: 0,
      navList: ['志愿指导', '录取信息', '录取信息'],
      list: [
        {
          image: require('../images/home/simg.png'),
          text: '清华大学',
          no: '1',
          star: require('../images/home/starA.png')
        },
        {
          image: require('../images/home/simg.png'),
          text: '清华大学',
          no: '1',
          star: require('../images/home/star.png')
        },
        {
          image: require('../images/home/simg.png'),
          text: '清华大学',
          no: '1',
          star: require('../images/home/star.png')
        },
        {
          image: require('../images/home/simg.png'),
          text: '清华大学',
          no: '1',
          star: require('../images/home/star.png')
        },
        {
          image: require('../images/home/simg.png'),
          text: '清华大学',
          no: '1',
          star: require('../images/home/star.png')
        },
        {
          image: require('../images/home/simg.png'),
          text: '清华大学',
          no: '1',
          star: require('../images/home/star.png')
        },
        {
          image: require('../images/home/simg.png'),
          text: '清华大学',
          no: '1',
          star: require('../images/home/star.png')
        },
        {
          image: require('../images/home/simg.png'),
          text: '清华大学',
          no: '1',
          star: require('../images/home/star.png')
        },
        {
          image: require('../images/home/simg.png'),
          text: '清华大学',
          no: '1',
          star: require('../images/home/star.png')
        },
        {
          image: require('../images/home/simg.png'),
          text: '清华大学',
          no: '1',
          star: require('../images/home/star.png')
        }
      ],
      currentOffset: 0,
      windowSize: 5,
      paginationFactor: 380
    }
  },
  computed: {
    atEndOfList() {
      return this.currentOffset <= this.paginationFactor * -1 * (this.list.length - this.windowSize)
    },
    atHeadOfList() {
      return this.currentOffset === 0
    }
  },
  methods: {
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor
      }
    },
    checkIndex(index) {
      this.navIndex = index
      console.log(index)
    },
    checkListIndex(index) {
      this.listIndex = index
    },
    tiaozhuan() {
      this.$router.push('/zyf')
    }
  }
}
</script>

<style >
.head-nav {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  background-color: white;
  /* justify-content: space-around; */
  box-sizing: border-box;
  align-items: center;
  padding-top: 25px;
  padding-bottom: 25px;
  padding-right: 40px;
  opacity: 1;
  height: 31px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  color: #f43626;
  margin-top: 50px;
}
.head-nav > .activite {
  font-weight: bold;
  border-bottom: 2px solid red;
  color: red;
  font-size: 20px;
  padding: 0px;
}
.head-nav > div {
  /* margin: 0 auto; */
  padding-bottom: 10px;
  padding-right: 50px;
  padding-left: 20px;
}
body {
  background: #f8f8f8;
  color: #2c3e50;
  font-family: 'Source Sans Pro', sans-serif;
  min-height: 1000px;
  padding: 0;
  margin: 0;
}

.card-carousel-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0 40px;
  color: #666a73;
  padding: 0 20px;
  box-sizing: border-box;
  overflow: hidden;
  border: 3px solid #000;
}

.card-carousel {
  animation: move 14s linear infinite;
  display: flex;
  justify-content: center;
}
@keyframes move {
  100% {
    /* 移动图片的全部宽的距离 */
    transform: translateX(-1280px);
  }
}
.card-carousel--overflow-container {
  float: left;
  overflow: hidden;
}
.card-carousel--nav__left,
.card-carousel--nav__right {
  display: inline-block;
  width: 47px;
  height: 40px;
  padding: 10px;
  box-sizing: border-box;
  border-top: 2px solid #42b883;
  border-right: 2px solid #42b883;
  cursor: pointer;
  margin: 0 10px;
  transition: transform 150ms linear;
}
.card-carousel--nav__left[disabled],
.card-carousel--nav__right[disabled] {
  opacity: 0.2;
  border-color: black;
}
.card-carousel--nav__left {
  transform: rotate(-135deg);
}
.card-carousel--nav__left:active {
  transform: rotate(-135deg) scale(0.9);
}
.card-carousel--nav__right {
  transform: rotate(45deg);
}
.card-carousel--nav__right:active {
  transform: rotate(45deg) scale(0.9);
}

.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
}
.card-carousel-cards .card-carousel--card {
  margin: 0 10px;
  cursor: pointer;
  box-shadow: 0 4px 15px 0 rgba(40, 44, 53, 0.06), 0 2px 2px 0 rgba(40, 44, 53, 0.08);
  background-color: #fff;
  border-radius: 4px;
  z-index: 3;
  margin-bottom: 2px;
}
.card-carousel-cards .card-carousel--card:first-child {
  margin-left: 0;
}
.card-carousel-cards .card-carousel--card:last-child {
  float: left;
  margin-right: 0;
}
.card-carousel-cards .card-carousel--card img {
  float: left;
  vertical-align: bottom;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  transition: opacity 150ms linear;
  user-select: none;
}
.card-carousel-cards .card-carousel--card img:hover {
  opacity: 0.5;
}
.card-carousel-cards .card-carousel--card--footer {
  border-top: 0;
  padding: 7px 15px;
}
.card-carousel-cards .card-carousel--card--footer p {
  padding: 3px 0;
  margin: 0;
  margin-bottom: 2px;
  font-size: 19px;
  font-weight: 500;
  color: #2c3e50;
  user-select: none;
}
.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2) {
  font-size: 12px;
  font-weight: 300;
  padding: 6px;
  background: rgba(40, 44, 53, 0.06);
  display: inline-block;
  position: relative;
  margin-left: 4px;
  color: #666a73;
}
.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2):before {
  content: '';
  float: left;
  position: absolute;
  top: 0;
  left: -12px;
  width: 0;
  height: 0;
  border-color: transparent rgba(40, 44, 53, 0.06) transparent transparent;
  border-style: solid;
  border-width: 12px 12px 12px 0;
}
.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2):after {
  content: '';
  position: absolute;
  top: 10px;
  left: -1px;
  float: left;
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background: white;
  box-shadow: -0px -0px 0px #004977;
}

h1 {
  font-size: 3.6em;
  font-weight: 100;
  text-align: center;
  margin-bottom: 0;
  color: #42b883;
}

.ms {
  width: 100%;
}
.ms > .title {
  width: 393px;
  height: 71px;
  background-image: url('../images/home/titbj.png');
  margin: 0px auto;
  background-size: 100% 100%;
  margin-top: 76px;
  font-size: 48px;
  font-weight: bold;
  text-align: center;
}
.ms > .title > .t1 {
  color: #000;
}
.ms > .title > .t2 {
  color: #e23737;
}
.ms > .tail {
  color: #e2e2e2;
  font-size: 16px;
  text-align: center;
  margin-bottom: 55px;
}
.ms .list {
  display: flex;
  justify-content: space-between;
  padding: 0px 5px;
  box-sizing: border-box;
  flex-wrap: wrap;
}
.itemtt {
  width: 49%;
  flex-grow: 0;
  flex-shrink: 0;
  margin: 0 15px;
}
.itemtt > .img {
  width: 100%;
  float: left;
  position: relative;
}
.itemtt > .img > img {
  width: 100%;
}
.itemtt > .star {
  width: 26px;
  height: 31px;
  position: absolute;
  left: auto;
  right: 20px;
  top: 0px;
}
.box > .star > img {
  width: 100%;
  height: 100%;
}
.itemtt > .img > .no {
  width: 63px;
  height: 20px;
  border-radius: 10px;
  background-color: #e95e5e;
  color: #fff;
  text-align: center;
  line-height: 20px;
  right: 10px;
  bottom: 10px;
  top: auto;
  left: auto;
  position: absolute;
  font-size: 12px;
}
.itemtt > .name {
  font-size: 16px;
  color: #151515;
  text-align: center;
  margin-top: 16px;
}
.ms .button {
  width: 160px;
  height: 39px;
  color: #e23737;
  border: 1px solid #e23737;
  text-align: center;
  box-sizing: border-box;
  border-radius: 19.5px;
  line-height: 37px;
  cursor: pointer;
  margin: 0px auto;
  margin-top: 29px;
}

@media (min-width: 768px) {
  .ms {
    width: 100%;
  }
  .ms > .title {
    width: 393px;
    height: 71px;
    background-image: url('../images/home/titbj.png');
    margin: 0px auto;
    background-size: 100% 100%;
    margin-top: 76px;
    font-size: 48px;
    font-weight: bold;
    text-align: center;
  }
  .ms > .title > .t1 {
    color: #000;
  }
  .ms > .title > .t2 {
    color: #e23737;
  }
  .ms > .tail {
    color: #e2e2e2;
    font-size: 16px;
    text-align: center;
  }
  .ms .list {
    display: flex;
    justify-content: space-between;
    padding: 0px 5px;
    box-sizing: border-box;
  }
  .itemtt {
    width: 19.8%;
    flex-grow: 0;
  }
  .itemtt > .img {
    width: 100%;
    position: relative;
  }
  .itemtt > .img > img {
    width: 100%;
  }
  .itemtt > .img > .star {
    width: 26px;
    height: 31px;
    position: absolute;
    left: auto;
    right: 20px;
    top: 0px;
  }
  .itemtt > .img > .star > img {
    width: 100%;
    height: 100%;
  }
  .itemtt > .img > .no {
    width: 63px;
    height: 20px;
    border-radius: 10px;
    background-color: #e95e5e;
    color: #fff;
    text-align: center;
    line-height: 20px;
    right: 10px;
    bottom: 10px;
    top: auto;
    left: auto;
    position: absolute;
    font-size: 12px;
  }
  .itemtt > .name {
    font-size: 16px;
    color: #151515;
    text-align: center;
    margin-top: 16px;
  }
  .ms .button {
    width: 160px;
    height: 39px;
    color: #e23737;
    border: 1px solid #e23737;
    text-align: center;
    box-sizing: border-box;
    border-radius: 19.5px;
    line-height: 37px;
    cursor: pointer;
    margin: 0px auto;
    margin-top: 29px;
  }
}

@media (min-width: 992px) {
  .ms {
    width: 100%;
  }
  .ms > .title {
    width: 393px;
    height: 71px;
    background-image: url('../images/home/titbj.png');
    margin: 0px auto;
    background-size: 100% 100%;
    margin-top: 76px;
    font-size: 48px;
    font-weight: bold;
    text-align: center;
  }
  .ms > .title > .t1 {
    color: #000;
  }
  .ms > .title > .t2 {
    color: #e23737;
  }
  .ms > .tail {
    color: #e2e2e2;
    font-size: 16px;
    text-align: center;
  }
  .ms .list {
    display: flex;
    justify-content: space-between;
    padding: 0px 5px;
    box-sizing: border-box;
  }
  .itemtt {
    width: 19.8%;
    flex-grow: 0;
  }
  .itemtt > .img {
    width: 100%;
    position: relative;
  }
  .itemtt > .img > img {
    width: 100%;
  }
  .itemtt > .img > .star {
    width: 26px;
    height: 31px;
    position: absolute;
    left: auto;
    right: 20px;
    top: 0px;
  }
  .itemtt > .img > .star > img {
    width: 100%;
    height: 100%;
  }
  .itemtt > .img > .no {
    width: 63px;
    height: 20px;
    border-radius: 10px;
    background-color: #e95e5e;
    color: #fff;
    text-align: center;
    line-height: 20px;
    right: 10px;
    bottom: 10px;
    top: auto;
    left: auto;
    position: absolute;
    font-size: 12px;
  }
  .itemtt > .name {
    font-size: 16px;
    color: #151515;
    text-align: center;
    margin-top: 16px;
  }
  .ms .button {
    width: 160px;
    height: 39px;
    color: #e23737;
    border: 1px solid #e23737;
    text-align: center;
    box-sizing: border-box;
    border-radius: 19.5px;
    line-height: 37px;
    cursor: pointer;
    margin: 0px auto;
    margin-top: 29px;
  }
}

@media (min-width: 1200px) {
  .ms {
    width: 100%;
  }
  .ms > .title {
    width: 393px;
    height: 71px;
    background-image: url('../images/home/titbj.png');
    margin: 0px auto;
    background-size: 100% 100%;
    margin-top: 76px;
    font-size: 48px;
    font-weight: bold;
    text-align: center;
  }
  .ms > .title > .t1 {
    color: #000;
  }
  .ms > .title > .t2 {
    color: #e23737;
  }
  .ms > .tail {
    color: #e2e2e2;
    font-size: 16px;
    text-align: center;
  }
  .ms .list {
    display: flex;
    justify-content: space-between;
    padding: 0px 5px;
    box-sizing: border-box;
  }
  .itemtt {
    width: 18.5%;
    flex-grow: 0;
  }
  .itemtt > .img {
    width: 100%;
    position: relative;
  }
  .itemtt > .img > img {
    width: 100%;
  }
  .itemtt > .img > .star {
    width: 32px;
    height: 37px;
    position: absolute;
    left: auto;
    right: 20px;
    top: 0px;
  }
  .itemtt > .img > .star > img {
    width: 100%;
    height: 100;
  }
  .itemtt > .img > .no {
    width: 73px;
    height: 26px;
    border-radius: 13px;
    background-color: #e95e5e;
    color: #fff;
    text-align: center;
    line-height: 26px;
    right: 10px;
    bottom: 10px;
    top: auto;
    left: auto;
    position: absolute;
  }
  .itemtt > .name {
    font-size: 20px;
    color: #151515;
    text-align: center;
    margin-top: 16px;
  }
  .ms .button {
    width: 160px;
    height: 39px;
    color: #e23737;
    border: 1px solid #e23737;
    text-align: center;
    box-sizing: border-box;
    border-radius: 19.5px;
    line-height: 37px;
    cursor: pointer;
    margin: 0px auto;
    margin-top: 29px;
  }
}
@media (max-width: 750px) {
  .card-carousel--nav__left {
    display: none;
  }
  .card-carousel--nav__right {
    display: none;
  }
  .card-carousel-cards {
    overflow-y: hidden;
    overflow-x: auto;
  }
  .topbar .content .hiddenItem {
    display: none;
  }
}

.texttt:hover {
  transform: scale(1.1, 1.1);
}

li {
  list-style: none;
}
.box {
  overflow: hidden;
  width: 1280px;
  height: 220px;
  /* border: 3px solid #000; */
  margin: 60px auto;
}
.box ul {
  width: 5000px;
  /* 动漫名称,时长,均速,无限循环 */
  animation: move 14s linear infinite;
}
.box ul li {
  /* display: block; */
  float: left;
}
.qinhua {
	overflow: hidden;
	width: 200px;
  height: 160px;
}
.box li img {
  width: 200px;
  height: 160px;
  transition: all 0.5s;
}
@keyframes move {
  100% {
    /* 移动图片的全部宽的距离 */
    transform: translateX(-1400px);
  }
}
.box:hover ul {
  /* 动画暂停  */
  animation-play-state: paused;
}

.box ul li .dahezi:hover .imgss {
  transform: scale(1.2);
}
.box .stars img {
  display: block;
  width: 50px;
  height: 50px;
	position: absolute;
  top: 30px;
  right: 0px;
  z-index: 99999;
}
.dahezi {
  margin-left: 20px;
  position: relative;
  float: left;
  width: 200px;
  height: 210px;
  /* border: 1px solid red; */
  overflow: hidden;
}
.box .stars {
  width: 26px;
  height: 31px;

}

.box .dahezi .no {
  width: 63px;
  height: 20px;
  border-radius: 10px;
  background-color: #e95e5e;
  color: #fff;
  text-align: center;
  line-height: 20px;
  right: 0px;
  bottom: 30px;
  /* left: auto; */
  position: absolute;
  font-size: 12px;
}
.name {
  font-size: 16px;
  color: #151515;
  text-align: center;
  /* margin-top: 10px; */
}
</style>



// WEBPACK FOOTER //
// src/views/home/item4.vue